export const visit = (vm, at) => {
at({ "zh-tw": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "\u65B0\u8A0A\u606F" } } } });
};